module.exports = __webpack_public_path__ + "static/image3-82a6d9db333d79b358814bebd8d69ea1.jpg";